import React, { useState, useRef } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Footer from "../../component/Footer/Footer";
import "./partslist.scss";
import PartslistTextField from "../../component/PartslistTextfieldComponent/PartslistTextField";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { safeEncode } from "../../common/encoder";
import Partlistpopup from "../../component/PartslistPopup";
import Paginations from "../../component/Pagination/PgmTextField";
import { Modal } from "react-bootstrap";
import PartorderlistButtons from "../../component/PartorderslistButtons";
import { partListAction ,addBulkpartAction ,partlistSearchInput , partlistPageValue , partListSort } from "../../actions/partAction";
import Loader from "../../component/loaderComponent/Loader";
import { NotificationManager } from "react-notifications";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import { dowloadPartsAction } from "../../actions/downloadAction";
import { useSelector } from "react-redux";
import NodataFound from "../../component/NodataFound";
import Cookies from "js-cookie";
import { safeDecode } from "../../common/decoder";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

function PartsList() {
  const pagedata=useSelector((state)=> state.partlistPage);
  const searchdata = useSelector((state) => state.partlistSearch);
  const [partList, setPartList] = useState([]);
  const [partGroup, setPartGroup] = useState([]);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(pagedata?.page);
  const [startIndex, setStartIndex] = useState(1);
  const [otherfile, setOtherfile] = useState(null);
  const [searchVehicle, setSearchVehicle] = useState(searchdata?.searchvaluedata?.value)
  const [Vehiclename, setVehiclename] = useState(searchdata?.searchvaluedata?.vehicle)
  const fileotherfile = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");

  useEffect(() => {
    setSearchVehicle('');
    setVehiclename('');
    dispatch(partlistSearchInput({ vehicle: '', value: '' }));
    PartListData();
    handleChangeLanguage(language);
    if(otherfile!=null){
      addBulkPart()
    }
  }, [page,otherfile]);

  useEffect(() => {
    if(searchVehicle.length === 0){
      PartListData()
    }
  },[searchVehicle])

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    setSearchVehicle(value.replace(/^ +/gm, ""));  
    var seardata = {
      vehicle: Vehiclename,
      value: value,
    };
    dispatch(partlistSearchInput(seardata));
  };
  const handelVehiclelistChange = (event) =>{
    setVehiclename(event.target.value)
    var seardata = {
      vehicle: event.target.value,
      value: searchVehicle,
    };
    dispatch(partlistSearchInput(seardata));
    if (event.target.value.length === 0) {
      window.location.reload()
    }
  }
  const handleFileotherfile = (event) => {
    const files = event.target.files[0];
    setOtherfile(files);
  };

  const handlePageChange = (event, value) => {
    dispatch(partlistPageValue(value));
    setPage(value);
  };
  
  async function PartListData(sortdata, columnName) {
    setIsLoading(true);
    const newStartIndex = (page - 1) * 15 + 1;
    setStartIndex(newStartIndex);
    let response = await dispatch(partListAction(page,searchVehicle, Vehiclename, sortdata, columnName));
    
    if (response == 200 || response != null) {
      if (response?.data?.data?.count % 15 == 0) {
        setCount(Math.floor(response?.data?.data?.count / 15));
      } else {
        setCount(Math.floor(response?.data?.data?.count / 15 + 1));
      }
      setPartList(response?.data?.data?.results);
      setPartGroup(response?.data?.meta?.discount_groups)
      if(response?.data?.data?.results[0]?.currency){
        Cookies.set("currency", response?.data?.data?.results[0]?.currency, {
          expires: 1,
        });
      }
      setIsLoading(false);
    }
  }
  const sortingData = (sortitem, columnName) =>{
    dispatch(partListSort(columnName, sortitem));
    PartListData(sortitem, columnName)
  } 
  const addBulkPart = async () => {
    let apiReq = {
      attachment:otherfile  
    };
    let response = await dispatch(addBulkpartAction(apiReq));
    if (response?.status == 200) {
      window.scroll(0, 0);
      NotificationManager.success(response?.data?.message);
    } else if (response?.status == 400){
      setTimeout(function() {
        window.location.reload();
    }, 2000); 
    } else if (response === undefined) {
      window.scroll(0, 0);
    }
  };

  async function filterSearch(name, id) {
    const defaultPage = 1;
    setPage(1);
    dispatch(partlistPageValue(1));
    setIsLoading(true);
    const newStartIndex = (page - 1) * 15 + 1;
    setStartIndex(newStartIndex);
    let response = await dispatch(partListAction(defaultPage, name, id));
    if (response == 200 || response != null) {
      if (response.data.data.count % 15 == 0) {
        setCount(Math.floor(response.data.data.count / 15));
      } else {
        setCount(Math.floor(response.data.data.count / 15 + 1));
      }
      setPartList(response.data.data.results);
      setIsLoading(false);
    }else if (response === undefined){
      setIsLoading(false);
    }
   
  }

  async function downloadParts() {
    try {
      const fileBlob = await dispatch(dowloadPartsAction());
      
      if (fileBlob) {
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        const fileName = `parts_${formattedDate}.csv`;
        const blobUrl = URL.createObjectURL(fileBlob);
        saveAs(blobUrl, fileName);
      }
    } catch (error) {
      NotificationManager.error("Error downloading file:", error);
    }
  }

  const handelclick = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };
  const Edit_parts = (Id) => {
    const encodeid = safeEncode(Id);
    navigate(`/editparts/${encodeid}`, { state: { partGroup } });
  };
  const Add_parts = () => {
    navigate("/addparts", { state: { partGroup } });
  };

  const Country_name = safeDecode(Cookies.get('country_name'));

  return (
    <div className="partlist_containers">
      <div className="partslist_container">
        <div className="partslistmain">
          <div className="header_border">
          <p className="pgm-list-header-text">TVS &gt; {t('partlist.partslist')}</p>
          </div>

          <div className="partslist_catainersorders">
            <PartorderlistButtons />
            <div className="partslistsscatainersorders">
              <img
                className="question_img"
                src={Image_Url.QUESTIONS}
                onClick={handelclick}
              />
              {hasPermission(PERMISSIONS.CAN_GENERATE_PART_EXCEL) && (
                <button className="dexcel" onClick={downloadParts}>
                  <img src={Image_Url.DEXCEL} className="downloads_imgdexcel" />
                  {t('partlist.partsinbulk')}
                </button>
              )}
              {hasPermission(PERMISSIONS.CAN_UPLOAD_PART_EXCEL) && (
                <button
                  className="AddpartsbulkAddpartsbulk"
                  onClick={() => fileotherfile.current.click()}
                >
                {t('partlist.addpartbulk')}
                  <input
                    className="business-contact-pages-input"
                    id="other_file"
                    onChange={handleFileotherfile}
                    hidden
                    type="file"
                    placeholder="+ Upload*"
                    name="userid"
                    accept=".xlsx,.xls,.csv"
                    ref={fileotherfile}
                  />
                </button>
              )}
              {hasPermission(PERMISSIONS.CAN_CREATE_PART) && (
                <button className="AddpartsbulkAddpartsbulk" onClick={Add_parts}>
                  {t('partlist.addpart')}
                </button>
              )}
            </div>
          </div>
          <PartslistTextField filterSearch={filterSearch} searchVehicle={searchVehicle} Vehiclename={Vehiclename} handleChange={handleChange} handelVehiclelistChange={handelVehiclelistChange} />
          <div className="pagination_margin">
            {isLoading ? (
              <Loader />
            ) : (
              <div className="tabledata">
                 {partList?.length > 0 ?
                <table className="table">
                  <tr>
                    <th className="tablesth"> {t('pgmlist.sNo')}</th>
                    <th className="tablesth flex_updown">
                    {t('partlist.partname')}
                      <span><FaAngleUp onClick={() => sortingData("asc", "name")} /><FaAngleDown onClick={() => sortingData("desc", "name")} /></span>
                    </th>
                    <th className="tablesth">{t('partlist.partid')}</th>
                    <th className="tablesth">{t('partlist.price')}</th>
                    {hasPermission(PERMISSIONS.CAN_VIEW_PART_DETAIL) && (
                      <th className="tablesth"></th>
                    )}
                  </tr>
                  {partList.map((data, i) => (
                    <tr key={i}>
                      <td className="tabletd">{i + startIndex}</td>
                      <td className="tabletdn">{data.name}</td>
                      <td className="tabletd">{data.part_number}</td>
                      <td className="tabletd">{data.currency} {data.price}</td>
                      {hasPermission(PERMISSIONS.CAN_VIEW_PART_DETAIL) && (
                        <td
                        className="tabletd_view"
                        onClick={() => {
                          Edit_parts(data.id);
                        }}
                      >
                        {t('partlist.edit')}
                      </td>
                      )}
                      
                    </tr>
                  ))}
                </table>
                :
                <NodataFound/>
                  }
              </div>
            )}
            <div className="pagination-div">
              <Paginations
                count={count}
                page={page}
                handlePageChange={handlePageChange}
              />
              {/* <Stack spacing={2}>
                <Pagination
                  count={count}
                  className="pagination"
                  page={page}
                  size="medium"
                  defaultPage={1}
                  color="primary"
                  onChange={handlePageChange}
                />
              </Stack> */}
            </div>
          </div>

          <Modal
            className="expertise-modal montserrat-font"
            show={show}
            onHide={handleClose}
          >
            <Modal.Body className="p-0 ">
              {show && (
                <Partlistpopup
                  handleClose={handleClose}
                  downloadParts={downloadParts}
                />
              )}
            </Modal.Body>
          </Modal>

          <div className="footer_div">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartsList;
